export interface TenantConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  customerServiceLine: string;
}

// ============================================
// 多租戶（Multi-tenant）配置對照表
// ============================================

// B 公司：舊專案（預設 fallback）
const B_COMPANY: TenantConfig = {
  supabaseUrl: "https://phohoiolistqzafaxoys.supabase.co",
  supabaseAnonKey:
    "sb_publishable_nYrRGLdnwxWCm7R22zwrkA_AQoiP-e4",
  customerServiceLine: "https://line.me/ti/p/hm5V5_QNCq",
};

// A 公司：新專案
const A_COMPANY: TenantConfig = {
  supabaseUrl: "https://iwpkrwlqfbafzkgfumud.supabase.co",
  supabaseAnonKey: "sb_publishable_z8ESYSYjbhv5EFpa8IauMw_QSlVAnre",
  customerServiceLine: "https://line.me/ti/p/g7_UHGZ38F",
};

/** 根據當前瀏覽器網域取得對應的 Supabase 配置 */
export function getCurrentTenantConfig(): TenantConfig {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "localhost";

  // --- localhost / 本機 IP 一律使用 B 公司 ---
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  ) {
    return B_COMPANY;
  }

  // --- 公司 A：hostname 包含 star-shopss.com 或 shinyshoppss.com ---
  if (
    hostname.includes("star-shopss.com") ||
    hostname.includes("shinyshoppss.com")
  ) {
    return A_COMPANY;
  }

  // --- 公司 B：hostname 包含 star-shops.com 或 shinyshops.com ---
  if (
    hostname.includes("star-shops.com") ||
    hostname.includes("shinyshops.com")
  ) {
    return B_COMPANY;
  }

  // --- 未匹配到的網域，回退使用 B 公司（舊專案） ---
  return B_COMPANY;
}

/** 取得當前 Edge Function 的 Base URL */
export function getEdgeBaseUrl(): string {
  const cfg = getCurrentTenantConfig();
  if (!cfg.supabaseUrl) return "";
  return `${cfg.supabaseUrl}/functions/v1`;
}